import React, { Component } from 'react';
import Switch from 'react-switch';
import PromotionApi from '../../functions/api/booking/PromotionApi';
import NotifyAlert from '../../components/Notify/NotifyAlert';

export default class ButtonActive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promotionInfo: props.row,
      check: props.row.is_show,
    };
  }

  componentWillReceiveProps(next) {
    this.setState({ promotionInfo: next.row, check: next.row.is_show });
  }

  handleChangeActive = async (checked, row) => {
    var check = checked;
    this.setState({ check });
    const params = { is_show: check };
    var value = await PromotionApi.update(
      this.state.promotionInfo.promo_id,
      params
    );
    if (!value || value['message']) {
      NotifyAlert('Lỗi', 'Không thể thay đổi trạng thái Show!');
    } else {
      NotifyAlert('Thành công', 'Chuyển trạng thái Show thành công!');
    }
  };
  render() {
    const { check } = this.state;
    return (
      <div>
        <label className="lable-option" style={{ margin: '0px' }}>
          <Switch
            onChange={this.handleChangeActive}
            checked={check}
            id="normal-switch"
          />
        </label>
      </div>
    );
  }
}
